<div class="row g-3">
    <div class="col-3">
        <div class="card">
            <div class="card-body">
                <h3 i18n>Settings</h3>
                <hr>
                <ul class="list-group">
                    <li routerLinkActive="bg-secondary" class="list-group-item d-flex align-items-center">
                        <a title="Users" routerLink="/settings/organization" i18n>Organization</a>
                    </li>
                    <li routerLinkActive="bg-secondary" class="list-group-item d-flex align-items-center">
                        <a title="Users" routerLink="/settings/billing" i18n>Billing</a>
                    </li>
                    <li routerLinkActive="bg-secondary" class="list-group-item d-flex align-items-center">
                        <a title="Users" routerLink="/settings/users" i18n>Users</a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="col-9">
        <router-outlet></router-outlet>
    </div>
</div>